import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/themeFour/APP6.png'
import _imports_1 from '@/assets/themeFour/pwa-money.png'
import _imports_2 from '@/assets/themeFour/btn1.png'
import _imports_3 from '@/assets/themeFour/download.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "app-promotion"
}
const _hoisted_3 = { class: "downContent" }
const _hoisted_4 = { class: "promotion-wrapper" }
const _hoisted_5 = { class: "icon_container" }
const _hoisted_6 = { style: {"color":"white"} }
const _hoisted_7 = {
  class: "promotion-content",
  style: {"color":"#fff"}
}

import { useUserStore } from '@/stores/user';
import { checkIosPWAInstallable, installPWA } from '@/view/home/supportScript';
import IosInstruction from '@/view/iosInstruction/iosInstruction.vue';
import { Capacitor } from '@capacitor/core';
import { ref, onBeforeMount, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'pwaDownloadCard',
  emits: ['intallPWA', 'isClosedPWA', 'showPWA'],
  setup(__props, { emit: __emit }) {

const promotion = ref(false);
const isPWA = ref(false);
const isNativeApp = ref(false);
const isIos = ref(false);
const iosInstructionPopup = ref(false);
const userStore = useUserStore()
const pwaDomainInfo = computed(() => userStore.PWAdomainInfo)

const emit = __emit;

const closePromotion = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    promotion.value = false;
    sessionStorage.setItem('openPromotionPopup', 'true');
    emit('isClosedPWA', promotion.value)
};

const closeInstructions = () => {
    iosInstructionPopup.value = false;
};


const installApp = () => {
    const url = pwaDomainInfo.value.domainName
    installPWA({
        url,
        isIos: isIos.value,
        iosPopupRef: iosInstructionPopup,
        emitInstall: () => emit('intallPWA')
    })
}


onBeforeMount(() => {
    isNativeApp.value = Capacitor.isNativePlatform();
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');

    promotion.value = true;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
    if (isStandalone || isNativeApp.value) {
        emit('isClosedPWA', false)
    }
    isIos.value = checkIosPWAInstallable()
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (promotion.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!isPWA.value && !isNativeApp.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_van_row, { style: {"align-items":"center"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "2",
                          onClick: closePromotion
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_van_icon, {
                                name: "cross",
                                color: "#fff",
                                size: "14"
                              })
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, { span: "3" }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                width: "40px",
                                height: "40px"
                              })
                            ], -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_van_col, { span: "9" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('pwaInstructions.title')), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, {
                          span: "2",
                          class: "gift-icon",
                          onClick: closePromotion
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              width: "100%"
                            }, null, -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_van_col, {
                          span: "7",
                          class: "installBtn",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createElementVNode("img", {
                              src: _imports_2,
                              alt: "",
                              width: "100%"
                            }, null, -1)),
                            _createElementVNode("div", { onClick: installApp }, [
                              _createVNode(_component_van_row, { class: "buttonContent" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_col, {
                                    span: "6",
                                    offset: "2",
                                    style: {"display":"flex","align-items":"center","justify-content":"right"}
                                  }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                      _createElementVNode("img", {
                                        src: _imports_3,
                                        alt: "",
                                        width: "90%"
                                      }, null, -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_van_col, {
                                    span: "15",
                                    offset: "1",
                                    style: {"display":"flex","align-items":"center","justify-content":"center","text-align":"center"},
                                    class: "download-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('pwaInstructions.toUpdate')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isIos.value && iosInstructionPopup.value)
      ? (_openBlock(), _createBlock(IosInstruction, {
          key: 1,
          onCloseInstructions: closeInstructions
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})